import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerRewardHandlerProvider } from '../../providers/consumer-reward-handler';
import { ConsumerRewardDetailPage } from '../../pages/consumer-reward-detail/consumer-reward-detail';
import { ConsumerRewardSharePage } from '../../pages/consumer-reward-share/consumer-reward-share';
import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';

import { Globals } from '../../providers/globals';
import { Utils } from '../../helpers/utils';

@Component({
  selector: 'page-consumer-reward-list',
  templateUrl: 'consumer-reward-list.html',
})
export class ConsumerRewardListPage {
	currentDate: any;
	hasRewards: boolean = true;

	filter: any = "available";

	params: any = {
		page: 1,
		size: 20,
		cb: null,
		filter: 'A'
	}

	isRefreshing: boolean = false;
	isLoading: boolean = false;
	lastRequestReturnedValues: boolean = false;

	filePath: any;

	constructor(
		public navCtrl: NavController, 
		public globals: Globals,
		public utils: Utils,
		public rewardProvider: ConsumerRewardHandlerProvider,
		public navParams: NavParams) {
		this.filePath = this.globals.fileUrl;

		this.currentDate = new Date();

		this.load(null);
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerRewardListPage');
	}

	ionViewWillEnter() {
		this.hasRewards = (this.rewardProvider.rewards.length > 0) ? true : false;
	}

	verifyExpiration(expirationDateStr){
		var currentDate = this.currentDate.getTime();
		var expirationDate = this.utils.getMilliseconds(expirationDateStr);

		var isValid = currentDate > expirationDate ? false : true;

		return isValid;

	}

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.params.page = 1;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	load(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;

		let params = {
			page: this.params.page,
			size: this.params.size,
			filter: this.params.filter,
			
			cb: (rewards)=>{
				this.isLoading = false;
				
				this.hasRewards = (rewards.length == 0 && this.params.page == 1) ? false : true;
				this.lastRequestReturnedValues = (rewards.length==0) ? false : true;

				if(this.params.page == 1){
					this.rewardProvider.rewards = rewards;	
				}else{
					for (var i = rewards.length - 1; i >= 0; i--) {
						this.rewardProvider.rewards.push(rewards[i]);
					}					
				}

				if(cb) cb()		
			}
		}

		this.rewardProvider.getRewards(params);
	}

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isRefreshing = true;

		this.params.page++;

		this.load(()=>{
			this.isRefreshing = false;
			
			infiniteScroll.complete();
		});
	}	

	gotoDetail(reward){
		if(reward.RedeemDate!=null) return;

		if(!this.verifyExpiration(reward.ExpirationDate)) return;
		
		this.rewardProvider.selectedReward = reward;

		this.navCtrl.push(ConsumerRewardDetailPage);			
	}

	gotoBusiness(id){
		this.navCtrl.push(ConsumerBusinessDetailPage, {
			requiresReload: true,
			businessId: id
		});			
	}

	goToShare(reward){
		this.rewardProvider.selectedReward = reward;

		this.navCtrl.push(ConsumerRewardSharePage);			
	}

	filterItems(filter){
		this.params.page = 1;
		this.params.filter = filter;

		this.load(null);
	}	
}



// WEBPACK FOOTER //
// ./src/pages/consumer-reward-list/consumer-reward-list.ts